import { Dialog, Transition } from '@headlessui/react'
import React, {Fragment} from 'react'
import XIcon from "@heroicons/react/solid/XIcon";
import {useTranslation} from "react-i18next";

export default function CodePopup({isOpen, setIsOpen, title, request, response}) {

    const { t } = useTranslation();

    // parse to JavaScript object
    const requestObject = JSON.parse(request);
    const responseObject = response ? JSON.parse(response) : false;

    // convert back to string with nice formatting
    const formattedRequest = JSON.stringify(requestObject, null, 2);
    const formattedResponse = response ? JSON.stringify(responseObject, null, 2) : false;

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog
                as="div"
                className="fixed inset-0 z-[400] overflow-y-auto"
                onClose={setIsOpen}
            >
                <div className="min-h-screen px-4 text-center">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 z-[390] bg-gray-900 bg-opacity-30 transition-opacity" />
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span
                        className="inline-block h-screen align-middle"
                        aria-hidden="true"
                    >&#8203;</span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <div className="relative z-[400] inline-block w-full max-w-2xl my-8 text-left align-middle transition-all transform bg-white shadow-xl">

                            <div className="flex justify-between border-b p-4 items-center">
                                <div>
                                    <h3 className="text-lg font-medium leading-6 text-blue-1000">{title}</h3>
                                </div>
                                <div>
                                    <button className="bg-white border-0" onClick={() => {setIsOpen(false)}}><XIcon className="w-4 h-4 fill-current flex-shrink-0 text-blue-1000" /></button>
                                </div>
                            </div>

                            <div className="p-4">
                                <h3 className="text-sm font-semibold text-gray-900 mb-1">
                                    {t("app.company_preference.request_body")}
                                </h3>
                                <code className="max-h-96 text-sm text-blue-1000 block whitespace-pre overflow-x-scroll bg-solitude-100 p-2 shadow-inner">
                                    {formattedRequest}
                                </code>

                                <h3 className="text-sm font-semibold text-gray-900 mt-3  mb-1">
                                    {t("app.company_preference.response_body")}
                                </h3>
                                <code className="max-h-96 text-sm text-blue-1000 block whitespace-pre overflow-x-scroll bg-solitude-100 p-2 shadow-inner">
                                    {response ? formattedResponse : t("app.common.not_found")}
                                </code>

                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    )
}
